import { useTooltip } from 'components/chartTooltip/useTooltip';
import d3 from "d3";
import { useCallback, FunctionComponent, useEffect } from 'react';


/**
 * A d3 function that selects the items to add tooltips to
 */
type ItemSelector<D> = () => d3.Selection<d3.BaseType,
                                          D,
                                          d3.BaseType,
                                          unknown>
/**
 * A React functional component that creates a tooltip from 
 * the data attached to a given selected item
 */
type ToolTipMaker<D> = FunctionComponent<D>

/**
 * A function for adding react based tooltips to a d3 svg
 */
export default function useReactTooltipsOnD3<Datum>(
                            itemSelector:ItemSelector<Datum>,
                            toolTipMaker:ToolTipMaker<Datum>,
                            toolTipOptions?
                        ):JSX.Element {
    const [toolTip, setupTrigger] = useTooltip(toolTipOptions);
    const getMouseEvents = useCallback(
        (d:Datum) => {
            return setupTrigger(toolTipMaker(d))
        },[setupTrigger,toolTipMaker]
	);
    useEffect(()=>{
        if(itemSelector) itemSelector()
            .on('mouseover', (e, d) => getMouseEvents(d).onMouseOver(e))
            .on('mouseout', (_, d) => getMouseEvents(d).onMouseOut());
    },[getMouseEvents,itemSelector])

    return toolTip
}